import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileSyncmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.625 4a.125.125 0 0 0-.125.125v.75c0 .069.056.125.125.125h6a.125.125 0 0 0 .125-.125v-.75A.125.125 0 0 0 10.625 4h-6Zm3 3.125v-.75A.125.125 0 0 0 7.5 6.25H4.625a.125.125 0 0 0-.125.125v.75c0 .069.056.125.125.125H7.5a.125.125 0 0 0 .125-.125Zm-.75 6.188H3.25v-11H12v5.374c0 .07.056.125.125.125H13a.125.125 0 0 0 .125-.125v-6a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v12.25a.5.5 0 0 0 .5.5h4.25A.125.125 0 0 0 7 14.313v-.876a.125.125 0 0 0-.125-.124Zm1.627-1.807a2.174 2.174 0 0 1 .637-1.428 2.194 2.194 0 0 1 3.24.158l-.36.28a.125.125 0 0 0-.013.186.124.124 0 0 0 .06.034l1.457.351a.126.126 0 0 0 .155-.12l.01-1.49a.125.125 0 0 0-.202-.1l-.317.246A3.19 3.19 0 0 0 7.5 11.495c-.003.07.055.13.125.13h.752a.124.124 0 0 0 .125-.119Zm5.248.119h-.752a.124.124 0 0 0-.125.119 2.172 2.172 0 0 1-.637 1.428 2.194 2.194 0 0 1-3.24-.158l.36-.28a.125.125 0 0 0-.047-.22l-1.457-.351a.126.126 0 0 0-.155.12l-.01 1.49a.125.125 0 0 0 .202.1l.317-.246a3.19 3.19 0 0 0 5.669-1.872.125.125 0 0 0-.125-.13Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgFileSyncmin);
export { ForwardRef as ReactComponent };
